import React from 'react';

import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import Label from 'ui-library/bs/Label';
import {InputChangeEvent} from 'util/Types';

interface Props {
  comment: string;
  onChange: (e: InputChangeEvent) => void;
}

export default function CommentFormGroup(props: Props): JSX.Element {
  return (
    <FormGroup>
      <Label>Comment</Label>
      <FormInput onChange={props.onChange} value={props.comment} />
    </FormGroup>
  );
}
